<app-nav></app-nav>
<div
  class="page-body-config"
  role="main"
>
  <ng-container *ngIf="reservationRequestSubmitted">
    <header>
      <h1 class="page-header">Book a Reservation</h1>
    </header>
    <div class="inner-content mx-auto pt-5">
      <div class="content mx-auto">
        <app-reservation-thank-you
          [locationName]="reservationRequestLocationName"
        ></app-reservation-thank-you>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!reservationRequestSubmitted">
    <header>
      <h1 class="page-header">Book a Reservation</h1>
    </header>
    <div id="main-content">
      <mat-tab-group
        class="left-stepper"
        [disableRipple]="true"
        [@.disabled]="true"
        [(selectedIndex)]="currentTabIndex"
        (selectedTabChange)="onTabChanged($event)"
      >
        <mat-tab
          aria-label="Location"
          label="Location"
          [disabled]="!enabledTabs.has(0)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-location
                #location
                [reservationRequest$]="reservationRequestService.reservationRequest$"
                (navigateToNext)="navigateToTabIndex(1, true)"
                (selectedLocationOut)="continueWithSelectedLocation($event)"
              ></app-reservation-location>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          aria-label="Dogs"
          label="Dog(s)"
          [disabled]="!enabledTabs.has(1)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-dogs
                #dog
                [needToReload$]="needToReloadDog$"
                (selectedPets)="continueWithSelectedPets($event)"
                (navigateToNext)="navigateToTabIndex(2, true)"
              ></app-reservation-dogs>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          aria-label="Services"
          label="Services"
          [disabled]="!enabledTabs.has(2)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-service
                #service
                [serviceCategories$]="reservationRequestService.availableServiceCategories$"
                [reservationRequest$]="reservationRequestService.reservationRequest$"
                (reservationRequestChange)="continueWithSelectedServices($event)"
                (navigateToNext)="navigateToTabIndex(3, true)"
              ></app-reservation-service>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          aria-label="Dates"
          label="Date(s)"
          [disabled]="!enabledTabs.has(3)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-date
                #date
                [useDateRange$]="useDateRange$"
                (navigateToNext)="navigateToTabIndex(4, true)"
                (selectedDateRange)="continueWithSelectedDate($event)"
              ></app-reservation-date>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          aria-label="Add-Ons"
          label="Add-Ons"
          [disabled]="!enabledTabs.has(4)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-add-ons
                #addOn
                [serviceCategories$]="reservationRequestService.availableServiceCategories$"
                [reservationRequest$]="reservationRequestService.reservationRequest$"
                (reservationRequestChange)="continueWithSelectedAddons($event)"
                (navigateToNext)="showSummary()"
              ></app-reservation-add-ons>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          aria-label="Summary"
          label="Summary"
          [disabled]="!enabledTabs.has(5)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-reservation-summary
                #summary
                [reservationRequest$]="reservationRequestService.reservationRequest$"
                [hasBoardingServiceSelected]="hasBoardingServiceSelected"
                (navigateToNext)="submitReservation()"
              >
              </app-reservation-summary>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>
</div>
<app-footer></app-footer>
